var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"shadow w-md-50",attrs:{"header-tag":"header","footer-tag":"footer"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h6',{staticClass:"m-0 font-weight-bold text-site-primary"},[_vm._v("Exams")])]},proxy:true}])},[_c('b-card-text',[_c('b-table',{attrs:{"hover":"","items":_vm.examList,"primary-key":"id","fields":[
        {
          key: 'id',
          label: 'ID',
          sortable: true
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'shortName',
          sortable: true,
        } ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }